import FormspreeForm from "../components/FormspreeForm";

export default function RequestDemo() {
  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 lg:grid-cols-2 gap-12" data-testid="request-demo-page">
      <div>
        <span className="eyebrow">Demo</span>
        <h1 className="font-display tracking-tighter text-5xl mt-4">Book a 20-minute walkthrough.</h1>
        <p className="text-slate-300 mt-4 leading-relaxed">
          We'll show you the swipe audit, the dashboard, and how lead reveal logic
          turns wellness into a measurable retention lever — with your branding.
        </p>

        <ul className="mt-10 space-y-3 text-sm text-slate-300">
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 mt-2 rounded-full bg-brand-glow" /> Live dashboard demo with sample data
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 mt-2 rounded-full bg-brand-glow" /> ROI model for your gym or business
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 mt-2 rounded-full bg-brand-glow" /> Pricing & rollout plan, no pressure
          </li>
        </ul>
      </div>

      <FormspreeForm topic="Request Demo" defaultMessage="I'd like to book a Fitest demo. My team size is …" />
    </div>
  );
}
